import { GroupNodeModel } from "@/models/nodes/GroupNodeModel";
import { OperatorType } from "@/models/nodes/operators";

import type { InlineNodeModel } from "@/models/nodes/InlineNodeModel";
import type { NodeModel } from "@/models/nodes/types";

export function calculateGroupDepthLevel(node: NodeModel): number {
  let count = 0;

  const nodeContainsGroupNode = node.descendants.filter(
    (n) => n.is(GroupNodeModel) || n.is(OperatorType.ROOT),
  );

  if (!nodeContainsGroupNode) {
    return count;
  }
  if (node.is(GroupNodeModel) || node.is(OperatorType.ROOT)) {
    count += 1;
  }

  const groupDepthCounts = node.nodes.map((n) => calculateGroupDepthLevel(n));
  const largestGroupDepthCount = groupDepthCounts.length > 0 ? Math.max(...groupDepthCounts) : 0;

  return count + largestGroupDepthCount;
}

export function isInsideCasesGroup(node?: InlineNodeModel) {
  const group = node?.ancestors.find((n) => n.is(GroupNodeModel));
  return !!group?.casesSystemEnabled;
}
